import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { AiOutlineUser } from 'react-icons/ai';
import { getInlineLoader } from "../Helpers";
import {
	STR_AVAILABLE_HOTELS,
	STR_CHANGE_PHONE_NUMBER,
	STR_CONSULTATION_FEE_PAYMENTS,
	STR_CONTACT_US,
	STR_MENU_HOTELS,
	STR_NO_RECORD,
	STR_NOTIFICATIONS,
	STR_PAYMENT_SETTINGS,
	STR_PERSONAL_SETTINGS,
	STR_RECENT_CROPS,
	STR_RECENT_ITEMS,
	STR_RECENT_REQUESTS,
	STR_SUBSCRIPTION_FEE_PAYMENTS,
	STR_UPDATE_PERSONAL_INFO,
	STR_UPDATE_USERNAME,
	STR_VIEW_MORE
} from "../Strings";
import { BsFillPersonLinesFill, BsPersonGear } from 'react-icons/bs';
import { MdContactPage, MdInfoOutline, MdOutlinePayment, MdOutlinePayments, MdOutlinePhonelinkSetup, MdOutlineSupport, MdSupportAgent, MdTranslate } from 'react-icons/md';
import { CgProfile } from "react-icons/cg";
import login_bg from '../assets/login_bg.jpg';
import HomeMenu from "./HomeMenu";
import WelcomeSlider from '../ones/WelcomeSlider';
import OneItem from "../ones/OneItem";
import PostsFeed from "./PostsFeed";
import Contributions from "../main-views/Contributions";

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);

	async function init() {
		//run initializations here
		setReady(false);
		
		setReady(true);
	}



	useEffect(() => {
		init();
	}, [])



	if (ready) {
		return (
			<div
				style={{
					width: "100%",
					height: "100%",
					overflow: "scroll",
					paddingTop: "20px",
					paddingBottom: "calc(var(--topBarHeight) + 40px)",
				}}
				className="mNoScrollBar"
			>
				<div className="container">

					<div className="row">

						<div className="col-md-12">
							<WelcomeSlider/>
						</div>

						<div className="col-md-12">
							<HomeMenu/>
						</div>

						<div className="col-md-12">
							
							
							{/*Posts Section here*/}
							<Contributions />
						</div>

					</div>

					

				</div>


			</div>
		)
	} else {
		return (
			<div
				className="mSupportLoading"
				style={{
					width: "100%",
					height: "100%",
				}}
			>
				{getInlineLoader()}
			</div>
		);
	}


}